import React from 'react'
import { Cell, Grid } from 'react-foundation'
import { County } from '../../models/User'
import { SelectFieldGroup } from '../Common/Input/FormFields'

type UserPreferences = {
    emails: string[]
    counties: County[]
    preferredEmail: string
    contactName: string
    contactPhone: string
    providerName: string
    address1: string
    city: string
    state: string
    zipCode: string

}

type BusinessInformationProps = {
    preferences?: UserPreferences
}

const BusinessInformation: React.FC<BusinessInformationProps> = ({ preferences }) => {
    const formatValue = (value?: string) => {
        const trimmed = value?.trim()
        return trimmed && trimmed.length > 0 ? trimmed : ''
    }

    const addressParts = [preferences?.address1, preferences?.city, preferences?.state]
        .map(part => part?.trim())
        .filter((part): part is string => !!part)
    const zipPart = preferences?.zipCode?.trim() || ''
    const formattedAddress = [
        addressParts.join(', '),
        zipPart
    ].filter(Boolean).join(' ')

    return (
        <Grid className="card card-two-column business-profile-card">
            <Cell small={12}>
                <h6 className="margin-none color-black preferences-section-title"><span className="margin-none fas fa-portrait"></span> <b>Business Profile</b></h6>
                <p className="font-small color-black">Update your business information and professional details</p>
            </Cell>
            <Grid>
                <Cell small={6}>
                    <h6 className="margin-none"><b>Business Name</b></h6>
                    <p className="margin-left color-gray readonly-profile-value">{formatValue(preferences?.providerName)}</p>
                </Cell>
                <Cell small={6}>
                    <h6 className="margin-none"><b>Contact Person</b></h6>
                    <p className="margin-left color-gray readonly-profile-value">{formatValue(preferences?.contactName)}</p>
                </Cell>
            </Grid>
            <Grid>
                <Cell small={6}>
                    <h6 className="margin-none"><b>Email Address</b></h6>
                    <p className="margin-left color-gray readonly-profile-value">{formatValue(preferences?.preferredEmail)}</p>
                </Cell>
                <Cell small={6}>
                    <h6 className="margin-none"><b>Phone Number</b></h6>
                    <p className="margin-left color-gray readonly-profile-value">{formatValue(preferences?.contactPhone)}</p>
                </Cell>
            </Grid>
            <Grid>
                <Cell small={12}>
                    <h6 className="margin-none"><b>Business Address</b></h6>
                    <p className="margin-left color-gray readonly-profile-value">{formattedAddress}</p>
                </Cell>
            </Grid>
        </Grid>                     
    )
}

export default BusinessInformation
